
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/calculators/delta-pro-ultra",
      function () {
        return require("private-next-pages/calculators/delta-pro-ultra/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/calculators/delta-pro-ultra"])
      });
    }
  